import { Route } from 'vue-router';
import store from '@/store';
import _ from 'lodash';

export async function requireAuth(to: Route, from: Route, next: Function) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    });
  } else {
    if (_.isUndefined(store.getters['user/authenticated'])) {
      store.dispatch('user/getMe');
    }
    if (store.getters['user/authenticated'] === false) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
    next();
  }
}

export function isLoggedIn() {
  const token = getToken();
  return !!token;
}

export function setToken(token: string) {
  localStorage.setItem('access_token', token);
}

export function getToken() {
  return localStorage.getItem('access_token');
}

export function clearToken() {
  localStorage.removeItem('access_token');
}
